import { EditCommitmentPlan } from '@/components/investors-page/investorDetailsPage/tabs/pacingTab/editCommitmentPlanPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const EditCommitmentPlanPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Edit Commitment Plan</title>
      </Head>
      <EditCommitmentPlan />
    </>
  );
};

export default EditCommitmentPlanPage;
